import hostname from '../../common/env/constants';

export function handleImageLoaded(e) {
    if (e.target.height >= e.target.width) {
        e.target.parentElement.className += ' vertical';
    }

    if (e.target.height < e.target.width) {
        e.target.parentElement.className += ' horizontal';
    }
}

export function formatLandscapeMetaImageUrl(url) {
    if (!url) return '';

    const resizerPath = 'https://paragon-images.azurewebsites.net/remote.axd/';
    const sizeAndQuality = '?quality=80&width=600';

    return url.replace('https://', resizerPath) + sizeAndQuality;
}

export function formatPortraitMetaImageUrl(url) {
    if (!url) return '';

    const resizerPath = 'https://paragon-images.azurewebsites.net/remote.axd/';
    const sizeAndQuality = '?quality=80&width=315';

    return url.replace('https://', resizerPath) + sizeAndQuality;
}

export function getDevices() {
    const devices = {
        mobileSm: 320,
        mobileLg: 414,
        tabletSm: 768,
        tabletLg: 1024,
        desktopXs: 1440,
        desktopSm: 1680,
        desktopMd: 1920,
        desktopLg: 2560,
        desktopXl: 3840
    };

    return devices;
}

export function getAreaImageUrl(area) {
    const defaultUrl = getPropertyErrorUrl();

    if (area.imageUrl) {
        return area.imageUrl;
    }

    return defaultUrl;
}

export function getPropertyImageUrl(property) {
    const defaultUrl = getPropertyErrorUrl();

    if (property.leadImgUrl) {
        return property.leadImgUrl;
    } else if (property.primaryImage) {
        return property.primaryImage;
    } else if (property.imageUrls) {
        if (property.imageUrls[0]) {
            return property.imageUrls[0];
        } else {
            return defaultUrl;
        }
    } else if (property.images) {
        if (property.images[0]) {
            return property.images[0].imageUrl;
        } else {
            return defaultUrl;
        }
    } else {
        return defaultUrl;
    }
}

export function getPropertyErrorUrl() {
    return `${hostname}/images/noPropertyImage.jpg`;
}

export function getAgentImageUrl(agent) {
    const defaultUrl = '/images/noAgentImage.jpg';
    if (!agent.imageUrl) {
        return defaultUrl;
    }

    return agent.imageUrl;
}

export function getAgentErrorUrl() {
    return '/images/noAgentImage.jpg';
}

export function getAgentImageAlt(agent) {
    return `${agent.fullName}, Real Estate Agent ${
        agent.officeName
    }, CA | PARAGON Real Estate Group`;
}

export function getMapImageUrl(store) {
    return store.desktopMapImage;
}



// WEBPACK FOOTER //
// ./src/common/utils/imageUtils.js